<template>
    <customModal :containersm="true" :footerShow="true" >
        <template #title> 
           Create visit schedule
        </template>
        <template #body>
            <div class="row">
                <div class="col-lg-6 mb-3">
                    <label class="form-label mb-0 me-2">Visit Name</label>
                    <input type="text" class="form-control" v-model="visitName" readonly>
                </div>
                <div class="col-lg-6 mb-3">
                    <label class="form-label mb-0 me-2">Planned Visit Date <sup><i class="fa fa-asterisk required"></i></sup>
                    </label>
                    <input type="date" class="form-control" v-model="payload.visitDetails[0].visitDate">
                    <span class="errormsg" v-if="errors[0]">
                        {{ $t("navigations.please enter visit date") }}
                    </span>
                </div>
                <div class="col-lg-12 mb-3">
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-primary btn-sm py-0 text-white mr-2 align-self-end"
                            @click="createVisitBasedSchedule()">
                            Create
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </customModal>
</template>
<script src="./VisitBasedSchedule.js"></script>